import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import { NavbarColumnGroup } from '@/components/elementary/navbar/NavbarColumnGroup';
import { Paragraph } from '@/components/typography/Paragraph';
import { NavigationMenuContent } from '@/components/ui/navigation-menu';
interface NavbarMenuPanelProps {
  readonly columns: Data.Component<'layout-utilities.navbar-item'>['columns'];
}
export function NavbarMenuPanel(t0) {
  const $ = _c(4);
  const {
    columns
  } = t0;
  let t1;
  if ($[0] !== columns) {
    t1 = columns?.map(_temp2);
    $[0] = columns;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <NavigationMenuContent className="lg:left-1/6 lg:-translate-x-1/6 xl:left-0 xl:translate-x-0 z-20"><ul className="bg-peach-100 rounded-md p-3 flex gap-4">{t1}</ul></NavigationMenuContent>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp2(column) {
  return <li key={column.id} className="flex flex-col gap-4 bg-neutral-light-100 rounded-sm p-5 w-60">{column.title && <Paragraph fontSize="bodyRegularExtraSmall" textColor="gray" className="pb-5 uppercase border-b border-b-neutral-300">{column.title}</Paragraph>}{column.groups?.map(_temp)}</li>;
}
function _temp(group) {
  return <NavbarColumnGroup key={group.id} group={group} />;
}